module.exports = locale;